import React, { useEffect, useState } from 'react';
import { Input, Dropdown, Button, AddRemove, toastMessage } from '../utils';
import { usePlantContext } from "../../context/plantContext";
import { useDevices } from '../../services/hooks';
import { buttonClasses } from "../utils/theme";
import { valid_email, valid_mobile } from '../../services/validation';
import { useUpdateDeviceAlertMutation } from '../../api/deviceSlice';
import { useUpdatePlantMutation } from "../../api/vmsSlice";
import { Tooltip } from "@mui/material";
import { ExpandMoreIcon, InfoIcon } from "../../services/icons";
import { usePlant } from '../../services/hooks';

const defaultAlert = {
            "id" : "",
            "displayName" : "",
            "alertConfig" : {
                "BoomOpen" : {alertThreshold: 0,
                cooldownPeriod: 0,
                notifyEmails: [],
                notifyMobiles: [],}
            }
}
const defaultForm = {
    alertConfig : [
		{
			filterType : "",
			filterValue : "",
			threshold: 10,
			startCheckpointNumber: 1,
			notifyEmails: [],
			notifyMobiles: []
		}
	]
}

// const itemTypeOptions = [
// 	{ label: "Product", value: "product" }, 
// 	{ label: "Product Category", value: "productCategory" }, 
// 	{ label: "Supplier", value: "supplier" }
// ];

// const defaultFilter = {
// 	pagesize: 10,
// 	page_no: 1,
// };

export default function AlertConfig() {
    const { plantOptions } = usePlantContext();
    // const filterRef = useRef(defaultFilter);
    // const { page_no = 1, pagesize = 20 } = filterRef.current;
    // const { productCategories, message, getProdCats } = useProductCategories(filterRef.current);
    // const { products, count: productCount, getProducts } = useProducts(filterRef.current);
    // const { suppliers, count: supplierCount, getSuppliers } = useSuppliers(filterRef.current);
    const [selectedPlant, setSelectedPlant] = useState(null);
    const { devices, count, isLoading, getDevices } = useDevices({
        pagesize: 1000,
        page_no: 1,
        plantIds: selectedPlant?.value,
        deviceType: "rfid"
    });
    const [handleUpdateDevice, { isLoading: isUpdating }] = useUpdateDeviceAlertMutation();
    let { plants, isLoading :isplantLoading, getPlantDetails } = usePlant({
        pagesize: 10,
        page_no: 1,
        plantIds: selectedPlant?.value,
        projection : ["alertConfig"]
    }, "alertConfigPlants");
    const [handleUpdate] = useUpdatePlantMutation();
    // const [JbOpen, setJbOpen] = useState({ 
    //   alertThreshold: 0,
    //   cooldownPeriod: 0,
    //   notifyEmails: [],
    //   notifyMobiles: [],
    // });
    const [formData, setFormData] = useState(defaultForm);
    const [deviceList, setDeviceList] = useState([]);
    const [error, setError] = useState({});

    useEffect(() => {
        if (!plantOptions?.length) return;

        setSelectedPlant((current) => {
            if (current && plantOptions.some((opt) => opt.value === current.value)) {
                return current;
            }

            return plantOptions[0] || null;
        });
    }, [plantOptions]);

    const handleAlertConfigChange = (value, name, id) => {
        if(true){
            setDeviceList((old) => old.map(item => 
                item.id === id ? {
                    ...item,
                    alertConfig: {
                        ...item.alertConfig,
                        BoomOpen: {
                            ...item.alertConfig.BoomOpen,
                            [name]: Array.isArray(value) ? value.map((_) => _.value) : value
                        }
                    }
                } : item
            ));
        }
    };
    const handleFormSubmit = async (formData) => {
        const validationErrors = validateFormData(formData);
        if (Object.keys(validationErrors).length > 0) {
            setError(validationErrors)
            return;
        }
        setError({})
        // console.log('formdata', plantId, selectedPlant);
        const {data: { error, message }} = await handleUpdateDevice({...formData, plantId : selectedPlant.value})
        // console.log({error, message})
        if (error) {
            toastMessage(false, message);
        } else {
            toastMessage(true, message);
            // navigate("/devices", { state: { filterData: filterData || "" } });
        }
    };

    const handleWarehouseAlertConfigChange = (value, name, index) => {
        setFormData(prev => ({
            ...prev,
            alertConfig: prev.alertConfig.map((config, i) => {
                if (i !== index) return config;

                // // If filterType changes → reset filterValue
                // if (name === "filterType") {
                //     return {
                //         ...config,
                //         filterType: value,
                //         filterValue: "" // reset
                //     };
                // }

                return {
                    ...config,
                    [name]: Array.isArray(value)
                        ? value.map(v => v.value)
                        : value?.value ?? value
                };
            })
        }));
    };

    const addAlertConfig = () => {
		setFormData((old) => ({
			...old,
			alertConfig: [
				...old.alertConfig,
				...defaultForm.alertConfig
			],
		}));
	};

    const removeAlertConfig = (index) => {
		setFormData((old) => ({
			...old,
			alertConfig: old.alertConfig.filter((_, i) => i !== index),
		}));
	};

    useEffect(() => {
        if (selectedPlant?.value) { // Fixed: check if selectedPlant exists
            getDevices({ pagesize: 1000, page_no: 1, plantIds: selectedPlant.value, deviceType: "rfid" });
            getPlantDetails({ pagesize: 10, page_no: 1, plantIds: selectedPlant.value, projection : ["alertConfig"] });
        }
    }, [selectedPlant]);

    useEffect(()=>{
        if(devices?.length > 0){
            const deviceList = devices.filter((el) => el.deviceSubType ==="customReader" && el.hasOwnProperty('alertConfig') && Object.keys(el.alertConfig?.BoomOpen).length > 0)?.map((el) => ({id : el._id, "displayName" : el.displayName, "alertConfig" : el.alertConfig})) || [];
            console.log('deviceList', deviceList)
            setDeviceList(deviceList)
        }else{
            setDeviceList([])
        }
    }, [devices])

    useEffect(() => {
        if (!plants || !plants[0]?.alertConfig) return;

        const plantAlertConfig = plants[0].alertConfig;

        // If backend gives object like { BoomOpen: {...} }
        // OR array → handle both safely

        let mappedConfigs = [];

        if (Array.isArray(plantAlertConfig)) {
            mappedConfigs = plantAlertConfig.map((item) => ({
                filterType: item.filterType || "",
                filterValue: item.filterValue || "",
                threshold: item.threshold || 10,
                startCheckpointNumber: item.startCheckpointNumber || 1,
                notifyEmails: item.notifyEmails || [],
                notifyMobiles: item.notifyMobiles || []
            }));
        } else {
            // fallback (if only BoomOpen exists)
            mappedConfigs = [
                {
                    filterType: "",
                    filterValue: "",
                    threshold: plantAlertConfig?.BoomOpen?.alertThreshold || 10,
                    startCheckpointNumber: 1,
                    notifyEmails: plantAlertConfig?.BoomOpen?.notifyEmails || [],
                    notifyMobiles: plantAlertConfig?.BoomOpen?.notifyMobiles || []
                }
            ];
        }

        setFormData({
            alertConfig: mappedConfigs
        });

    }, [plants]);

    // useEffect(() => {
    //     if (!plants || !plants[0]?.alertConfig) return;

    //     // wait until dropdown data is loaded (IMPORTANT)
    //     if (!products || !suppliers || !productCategories) return;

    //     const plantAlertConfig = plants[0].alertConfig;

    //     let mappedConfigs = [];

    //     if (Array.isArray(plantAlertConfig)) {
    //         mappedConfigs = plantAlertConfig.map((item) => ({
    //             filterType: item.filterType || "",
    //             filterValue: item.filterValue || "",
    //             threshold: item.threshold ?? 10,
    //             startCheckpointNumber: item.startCheckpointNumber ?? 1,
    //             notifyEmails: item.notifyEmails || [],
    //             notifyMobiles: item.notifyMobiles || []
    //         }));
    //     }

    //     else if (typeof plantAlertConfig === "object") {
    //         mappedConfigs = [
    //             {
    //                 filterType: "",
    //                 filterValue: "",
    //                 threshold: plantAlertConfig?.BoomOpen?.alertThreshold ?? 10,
    //                 startCheckpointNumber: 1,
    //                 notifyEmails: plantAlertConfig?.BoomOpen?.notifyEmails || [],
    //                 notifyMobiles: plantAlertConfig?.BoomOpen?.notifyMobiles || []
    //             }
    //         ];
    //     }

    //     setFormData({
    //         alertConfig: mappedConfigs.length > 0
    //             ? mappedConfigs
    //             : defaultForm.alertConfig
    //     });

    // }, [plants, products, suppliers, productCategories]);

    // const getFilterValueOptions = (type) => {
    //     switch (type) {
    //         case "supplier":
    //             return suppliers
    //                 ?.filter(el => el.plantId === plants?.[0]?._id)
    //                 ?.map(ele => ({ label: ele.supplierName, value: ele._id })) || [];

    //         case "product":
    //             return products
    //                 ?.filter(el => el.plantId === plants?.[0]?._id)
    //                 ?.map(ele => ({ label: ele.productName, value: ele._id })) || [];

    //         case "productCategory":
    //             return productCategories
    //                 ?.filter(el => el.plantId === plants?.[0]?._id)
    //                 ?.map(ele => ({ label: ele.productCategory, value: ele._id })) || [];

    //         default:
    //             return [];
    //     }
    // };

    const handleWarehouseFormSubmit = async () => {
        console.log('formData to submit', formData);

        const errors = {};

        // formData.alertConfig.forEach((config, index) => {

        //     // ✅ Threshold validation
        //     if (!config.threshold || config.threshold <= 0) {
        //         errors[`threshold-${index}`] = "Alert threshold must be greater than 0";
        //     }

        //     // ✅ Either email OR mobile required
        //     if (
        //         (!config.notifyEmails || config.notifyEmails.length === 0) &&
        //         (!config.notifyMobiles || config.notifyMobiles.length === 0)
        //     ) {
        //         errors[`notifyEmails-${index}`] = "Provide at least one email or mobile";
        //         errors[`notifyMobiles-${index}`] = "Provide at least one email or mobile";
        //     }

        //     // // ✅ filterType → filterValue required
        //     // if (config.filterType && !config.filterValue) {
        //     //     errors[`filterValue-${index}`] = "Please select item";
        //     // }
        // });

        if (Object.keys(errors).length > 0) {
            console.log('validation errors', errors);
            setError(errors);
            return;
        }

        setError({});

        let updatePayload = {
            id: plants[0]?._id,
            updateData: {
                ...formData,
            },
        };

        const {
            data: { error, message },
        } = await handleUpdate(updatePayload);

        if (error) {
            toastMessage(false, message);
        } else {
            toastMessage(true, message);
        }
    };


    return (
      <div style={{ padding: "10px", paddingTop: "20px" }}>
        <div style={{ minWidth: "200px" }}>
          {plantOptions && plantOptions.length > 1 ? (
            <Dropdown
              label="Select Warehouse"
              options={plantOptions || []}
              value={selectedPlant}
              onChange={(value) => setSelectedPlant(value)}
              // disabled={loading || !plantOptions || plantOptions.length === 0}
              // disableClearable={true}
            />
          ) : null}
        </div>
        {deviceList.length > 0 &&
          deviceList.map((device, index) => (
            <div key={device.id || index}>
              <h6 style={{ marginTop: "10px" }}>Boom Open Alert :</h6>
              <div style={{ display: "flex", gap: "0.5rem", width: "100%", flexDirection: "column", marginBottom: "10px" }} className="p-3 border boder-rad-10p ">
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }} >
                  <Input label="Device Name" value={device.displayName} error={error.id} readOnly sxi={{background : "#f0f0f0"}}/>
                  <Input
                    type="number"
                    id={`alertThreshold-${device.id}`}
                    name="alertThreshold"
                    value={device.alertConfig.BoomOpen.alertThreshold || 0}
                    label="Alert Threshold (sec)"
                    onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, device.id)}
                    required={true}
                    error={error.BoomOpen?.alertThreshold || error.BoomOpenAlertThreshold}
                    sx={{ width: "160px" }}
                  />
                  <Input
                    type="number"
                    id={`cooldownPeriod-${device.id}`}
                    name="cooldownPeriod"
                    value={device.alertConfig.BoomOpen.cooldownPeriod || 0}
                    label="Cooldown Period (sec)"
                    onChange={(e) => handleAlertConfigChange(e.target.value, e.target.name, device.id)}
                    required={true}
                    error={error.BoomOpen?.cooldownPeriod || error.BoomOpenCooldownPeriod}
                    sx={{ width: "160px" }}
                  />
                  <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                    <Dropdown
                      id={`notifyEmails-${device.id}`}
                      name="notifyEmails"
                      label="Notify Emails"
                      onChange={(option, name) => handleAlertConfigChange(option, name, device.id)}
                      options={device.alertConfig.BoomOpen.notifyEmails?.length > 0 ? device.alertConfig.BoomOpen.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                      value={device.alertConfig.BoomOpen.notifyEmails?.length > 0 ? device.alertConfig.BoomOpen.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                      enableCustomValue={true}
                      validateValue={(value) => valid_email(value)}
                      error={error.BoomOpen?.notifyEmails || error.BoomOpenNotifyEmails}
                      multiple={true}
                      required
                    />
                    <Tooltip style={{ marginLeft: "1px" }} title="Type email and press Enter to add to list. Multiple emails supported.">
                      <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                    </Tooltip>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                    <Dropdown
                      id={`notifyMobiles-${device.id}`}
                      name="notifyMobiles"
                      label="Notify Mobiles"
                      onChange={(option, name) => handleAlertConfigChange(option, name, device.id)}
                      options={device.alertConfig.BoomOpen.notifyMobiles?.length > 0 ? device.alertConfig.BoomOpen.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                      value={device.alertConfig.BoomOpen.notifyMobiles?.length > 0 ? device.alertConfig.BoomOpen.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                      enableCustomValue={true}
                      validateValue={(value) => valid_mobile(value)}
                      error={error.BoomOpen?.notifyMobiles || error.BoomOpenNotifyMobiles}
                      multiple={true}
                      required
                    />
                    <Tooltip style={{ marginLeft: "1px" }} title="Type mobile and press Enter to add to list. Multiple mobile number supported.">
                        <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                    </Tooltip>
                  </div>
                </div>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem" }}>
                  <Button text={"Update"} style={{ ...buttonClasses.lynkitOrangeFill, width: "15%" }} onClick={() => handleFormSubmit(device)} />
                </div>
              </div>
            </div>
          ))}
        <div className="theme-container">
          <h6>Overstay Alert Configuration</h6>
          {formData.alertConfig.map((config, index) => (
            <div key={index} style={{ display: "flex", gap: "0.5rem", width: "100%", marginBottom: "10px" }}>
              <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }} className="p-3 border boder-rad-10p ">
                {/* {true && <><div style={{ display: "flex", alignItems: "center", minWidth: "220px" }}> */}
                {/* <Dropdown
                                id="filterType"
                                name="filterType"
                                value={
                                    config.filterType
                                        ? itemTypeOptions.find(opt => opt.value === config.filterType)
                                        : null
                                }
                                options={itemTypeOptions}
                                label="Item Type"
                                onChange={(option, name) =>
                                    handleWarehouseAlertConfigChange(option?.value, name, index)
                                }
                                error={error[`filterType-${index}`]}
                                
                            /> */}
                {/* </div> */}
                {/* <div style={{ display: "flex", alignItems: "center", minWidth: "220px" }}> */}
                {/* <Dropdown
                                id="filterValue"
                                name="filterValue"
                                value={
                                    config.filterValue
                                        ? getFilterValueOptions(config.filterType)
                                            .find(ele => ele.value === config.filterValue)
                                        : null
                                }
                                options={getFilterValueOptions(config.filterType)}
                                label="Item"
                                onChange={(option, name) =>
                                    handleWarehouseAlertConfigChange(option, name, index)
                                }
                                error={error[`filterValue-${index}`]}
                            /> */}
                {/* </div></>} */}
                <Input
                  type="number"
                  id={`Alert Threshold`}
                  name="threshold"
                  value={config.threshold}
                  label="Alert Threshold (sec)"
                  onChange={(e) => handleWarehouseAlertConfigChange(e.target.value, e.target.name, index)}
                  min="0"
                  error={error[`threshold-${index}`]}
                />
                <Input
                  type="number"
                  id={`startCheckpointNumber`}
                  name="startCheckpointNumber"
                  value={config.startCheckpointNumber || 1}
                  label="Start Checkpoint Number"
                  onChange={(e) => handleWarehouseAlertConfigChange(e.target.value, e.target.name, index)}
                  min="1"
                />
                <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                  <Dropdown
                    id={`notifyEmails`}
                    name="notifyEmails"
                    label="Notify Emails"
                    onChange={(option, name) => handleWarehouseAlertConfigChange(option, name, index)}
                    options={config.notifyEmails?.length > 0 ? config.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                    value={config.notifyEmails?.length > 0 ? config.notifyEmails.map((el) => ({ label: el, value: el })) : []}
                    enableCustomValue={true}
                    validateValue={(value) => valid_email(value)}
                    multiple={true}
                    error={error[`notifyEmails-${index}`]}
                  />
                  <Tooltip style={{ marginLeft: "1px" }} title="Type email and press Enter to add to list. Multiple emails supported.">
                    <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                  </Tooltip>
                </div>
                <div style={{ display: "flex", alignItems: "center", minWidth: "280px" }}>
                  <Dropdown
                    id={`notifyMobiles`}
                    name="notifyMobiles"
                    label="Notify Mobiles"
                    onChange={(option, name) => handleWarehouseAlertConfigChange(option, name, index)}
                    options={config.notifyMobiles?.length > 0 ? config.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                    value={config.notifyMobiles?.length > 0 ? config.notifyMobiles.map((el) => ({ label: el, value: el })) : []}
                    enableCustomValue={true}
                    validateValue={(value) => valid_mobile(value)}
                    multiple={true}
                    error={error[`notifyMobiles-${index}`]}
                  />
                  <Tooltip style={{ marginLeft: "1px" }} title="Type mobile and press Enter to add to list. Multiple mobile number supported.">
                    <InfoIcon sx={{ fill: "#ff7200", marginLeft: "-15px", marginRight: "15px" }} />
                  </Tooltip>
                </div>
                <AddRemove list={formData.alertConfig} filterMethod={(item) => !item.threshold} onAdd={addAlertConfig} onRemove={removeAlertConfig} index={index} outerIndex={index} maxAddLimit={3} />
              </div>
            </div>
          ))}
          <div className="" style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "1rem" }}>
            <Button text={"Update"} style={{ ...buttonClasses.lynkitOrangeFill, width: "15%" }} onClick={handleWarehouseFormSubmit} />
          </div>
        </div>
      </div>
    );
}


const validateFormData = (formData) => {
    const errors = {};

    // Validate ID
    if (!formData.id || formData.id.trim() === '') {
        errors.id = 'Device ID is required';
    }

    // Validate displayName
    if (!formData.displayName || formData.displayName.trim() === '') {
        errors.displayName = 'Device name is required';
    }

    // Validate alertConfig exists
    if (!formData.alertConfig || typeof formData.alertConfig !== 'object') {
        errors.alertConfig = 'Alert configuration is required';
        return errors; // Return early if no alertConfig
    }

    // Validate each alert type (BoomOpen, JbOpen, etc.)
    // Object.entries(formData.alertConfig).forEach(([alertType, alertConfig]) => {
    //     const alertErrors = {};
    //     if(alertType === 'BoomOpen'){
    //         // console.log('alertConfig', alertConfig)
    //         // Validate alertThreshold
    //         if (!alertConfig.alertThreshold || alertConfig.alertThreshold == 0) {
    //             alertErrors.alertThreshold = `Alert threshold is required`;
    //         } else if (isNaN(alertConfig.alertThreshold) || Number(alertConfig.alertThreshold) < 0) {
    //             alertErrors.alertThreshold = `Alert threshold must be a positive number`;
    //         }

    //         // Validate cooldownPeriod
    //         if (!alertConfig.cooldownPeriod || alertConfig.cooldownPeriod == 0) {
    //             alertErrors.cooldownPeriod = `Cooldown period is required`;
    //         } else if (isNaN(alertConfig.cooldownPeriod) || Number(alertConfig.cooldownPeriod) < 0) {
    //             alertErrors.cooldownPeriod = `Cooldown period must be a positive number`;
    //         }

    //         // Validate notifyEmails
    //         // if (!alertConfig.notifyEmails || !Array.isArray(alertConfig.notifyEmails)) {
    //         //     alertErrors.notifyEmails = `Notify emails must be an array`;
    //         // } else {
    //         //     alertConfig.notifyEmails.forEach((email, index) => {
    //         //         if (!valid_email(email)) {
    //         //             if (!alertErrors.notifyEmails) alertErrors.notifyEmails = [];
    //         //             alertErrors.notifyEmails[index] = 'Invalid email format';
    //         //         }
    //         //     });
    //         //     // If all emails are valid but array is empty
    //         //     if (alertConfig.notifyEmails.length === 0) {
    //         //         alertErrors.notifyEmails = 'At least one email is required';
    //         //     }
    //         // }

    //         // Validate notifyMobiles
    //         // if (!alertConfig.notifyMobiles || !Array.isArray(alertConfig.notifyMobiles)) {
    //         //     alertErrors.notifyMobiles = `Notify mobiles must be an array`;
    //         // } else {
    //         //     alertConfig.notifyMobiles.forEach((mobile, index) => {
    //         //         if (!valid_mobile(mobile)) {
    //         //             if (!alertErrors.notifyMobiles) alertErrors.notifyMobiles = [];
    //         //             alertErrors.notifyMobiles[index] = 'Invalid mobile number format';
    //         //         }
    //         //     });
    //         //     // If all mobiles are valid but array is empty
    //         //     if (alertConfig.notifyMobiles.length === 0) {
    //         //         alertErrors.notifyMobiles = 'At least one mobile number is required';
    //         //     }
    //         // }

    //         // If there are errors for this alert type, add them to main errors
    //         if (Object.keys(alertErrors).length > 0) {
    //             errors[alertType] = alertErrors;
    //         }

    //     }
        
    // });

    return errors;
};
